import { useState } from 'react';
import { useForm } from 'react-hook-form';
import SuccessErrorMsg from "../../../../utilities/SuccessErrorMsg"
import { handleImageChange } from "../../../../utilities/handleFunctions/HandelImageChange"
import { emailValidation, mobileValidation } from "../../../../utilities/validations/inputsValidations"
import { toast, ToastContainer } from "react-toastify";
import { editAdvServicesform } from '../../../../hooks/apiAxios';


export function AdvServiceModify({ serviceName, serviceName_en, serviceId, serviceThumbnail, serviceImgAlt, description, description_en, enabled, supplierName, supplierEmail, supplierPhone, serviceSampleImg }) {
    const [image, setImage] = useState(serviceThumbnail);
    const { register, handleSubmit, formState: { errors }, setValue } = useForm({
        defaultValues: {
            type: "advanced",
            // description: description,
        }
    });
    // const [dataUpdate, setDataUpdate] = useState(false);
    const [loading, setLoading] = useState(false);

    async function onSubmit(data) {
        setLoading(true);
        console.log(data);


        const formData = new FormData();

        formData.append("image", data.image);
        formData.append("name", data.name);
        formData.append("nameAr", data.nameAr);
        formData.append("enabled", data.enabled);
        formData.append("description", data.description);
        formData.append("descriptionAr", data.descriptionAr);

        // Prepare supplier info as JSON array
        const supplierArray =
        {
            "name": data.supplier?.name,
            "email": data.supplier?.email,
            "phone": data.supplier?.phone,
        };

        // Append supplier JSON
        formData.append("supplier", JSON.stringify(supplierArray));

        try {
            const response = await editAdvServicesform(serviceId, formData);

            if (response.data.isSuccess) {
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
                toast.success("تم تعديل الخدمة بنجاح");
            } else {
                toast.error("حدث خطأ ما، حاول مرة أخرى");
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            toast.error("حدث خطأ ما، تواصل مع الدعم");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div id={`AdvServ${serviceId}`}
            className="modal fade bg-transparent"
            tabIndex="-1"
            aria-hidden="true"
            aria-labelledby="AdvServiceEditForm"
            data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="AdvServiceEditForm">تعديل</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body p-0">

                        <form
                            encType="multipart/form-data"
                            method="patch"
                            className='d-flex flex-column flex-md-row shadow mx-auto gap-2 text-start bg-white px-2 pb-4 rounded align-items-center'
                            onSubmit={handleSubmit(onSubmit)}>

                            <div className="book-image-container position-relative m-auto mt-3 mt-md-5 ms-md-2">
                                <img className="book-image mx-auto w-100"
                                    crossOrigin="anonymous"
                                    src={image ? image : serviceSampleImg} alt={serviceImgAlt}
                                />
                                <h6 className="book-change-text border text-center">تغير الصورة</h6>
                                <input
                                    className="opacity-0 profile-image-input"
                                    type="file"
                                    accept="image/jpeg"
                                    // onChange={(e) => handleBookImageChange(e, setValue, setImage)}
                                    onChange={(e) => handleImageChange(e, setValue, setImage)}
                                />
                            </div>

                            <div className="d-flex flex-column col-11 col-md-8 ms-4 mb-5 my-md-5 gap-1">

                                {/* Input fields */}

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">الخدمة</span>
                                    <input
                                        className={`form-control ${errors.nameAr && "border border-danger"}`}
                                        type="text"
                                        defaultValue={serviceName}
                                        // onChange={(e) => { setValue("title", e.target.value) }}
                                        {...register("nameAr", { required: true, minLength: 10 })}
                                    />
                                    {errors.nameAr && <p className='errors-msg'>الاسم مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">Service</span>
                                    <input
                                        className={`form-control ${errors.name && "border border-danger"}`}
                                        type="text"
                                        defaultValue={serviceName_en}
                                        // onChange={(e) => { setValue("title", e.target.value) }}
                                        {...register("name", { required: true, minLength: 10 })}
                                    />
                                    {errors.name && <p className='errors-msg'>الاسم مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >مزود الخدمة</span>
                                    <input
                                        className='form-control'
                                        type="text"
                                        name='supplierName'
                                        required
                                        defaultValue={supplierName}
                                        {...register("supplier.name", { required: true })}
                                    // onChange={(e) => { setValue("supplier.name", e.target.value) }}
                                    />
                                    {errors.supplierName && <p className='errors-msg'>أدخل اسم مزود الخدمة</p>}
                                </div>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >بريد مزود الخدمة</span>
                                    <input className='form-control text-start'
                                        type="email" placeholder="البريد الالكتروني"
                                        defaultValue={supplierEmail}
                                        name='supplierEmail'
                                        required
                                        {...register("supplier.email", { required: true, pattern: emailValidation })}
                                    // onChange={(e) => { setValue("supplier.email", e.target.value) }}

                                    />
                                    {errors.supplierEmail && <p className='errors-msg'>أدخل البريدالالكتروني</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >جوال مزود الخدمة</span>
                                    <input className='form-control text-start'
                                        type="tel" placeholder="05xxxxxxxx"
                                        defaultValue={supplierPhone}
                                        name='supplierPhone'
                                        required
                                        {...register("supplier.phone", { required: true, pattern: mobileValidation })}
                                    // onChange={(e) => { setValue("supplier.phone", e.target.value) }}

                                    />
                                    {errors.supplierPhone && <p className='errors-msg'>أدخل رقم الجوال الصحيح</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >متوفر</span>
                                    <select className='form-select text-start'
                                        {...register("enabled")}
                                        defaultValue={enabled}
                                    >
                                        <option value={true}>متوفر</option>
                                        <option value={false}>غير متوفر</option>
                                    </select>
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">تفاصيل</span>
                                    <textarea
                                        className={`form-control ${errors.descriptionAr && "border border-danger"}`}
                                        type="textArea"
                                        rows="5"
                                        // onChange={(e) => { setValue("description", e.target.value) }}
                                        defaultValue={description}
                                        placeholder='تفاصيل الخدمة'
                                        // required
                                        {...register("descriptionAr", { minLength: 10 })} />
                                    {errors.descriptionAr && <p className='errors-msg'> مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">Details</span>
                                    <textarea
                                        className={`form-control ${errors.description && "border border-danger"}`}
                                        type="textArea"
                                        rows="7"
                                        onChange={(e) => { setValue("description_en", e.target.value) }}
                                        defaultValue={description_en}
                                        placeholder='Details'
                                        {...register("description", { required: true, minLength: 10 })} />
                                    {errors.description && <p className='errors-msg'> مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                            </div>
                            <button
                                className='btn btn-dark-orange text-white col-2 me-3 mb-3 position-absolute bottom-0 end-0'
                                type="submit">
                                {loading &&
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"></span>
                                }
                                حفظ
                            </button>
                        </form>
                        <SuccessErrorMsg
                            ToastContainer={ToastContainer}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}